<app-nav></app-nav>
<section class="insuropedia-panel">
  <div class="container">
    <div class="col">
      <div class="col mt-4">
          <form class="search-container" name="form" #f="ngForm" ng-submit="searchInsuropediaResult(searchContent)">
              <input type="text" id="search-bar" placeholder="Have a Question?" [(ngModel)]="searchContent" name="searchContent">
              <input type="submit" (click)="searchInsuropediaResult(searchContent)" class="search-icon" value="">
            </form>
      </div>
      <div class="col">
        <h4 class="heading">Results for "{{searchKey}}"</h4>
      </div>
      <div class="content-insuro mt-4 mb-4" *ngFor="let data of insuroData">
        <div class="col-12">
            <div class="title mt-2 mb-3">{{data.title}}</div>
            <div class="content overText">{{data.content}}</div>
            <a href="{{data.link}}" class="read-more mt-4 mb-3">Read More</a>
        </div>
      </div>
    </div>
  </div>
  <div id="spinner" [hidden]="!loading">
    <div class="spinnerfull">
      <i class="fa fa-spinner fa-spin fa-3x"></i>
    </div>
  </div>
</section>